import { render, staticRenderFns } from "./BaseBarItem.vue?vue&type=template&id=0eb7b554"
import script from "./BaseBarItem.vue?vue&type=script&lang=js"
export * from "./BaseBarItem.vue?vue&type=script&lang=js"
import style0 from "./BaseBarItem.vue?vue&type=style&index=0&id=0eb7b554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports